import { CustomDialog, DialogButtonsWrapper } from '@ui/uikit/components/common/Dialog';

export const UnsupportedBrowserModal = ({
  link,
  isOpen,
  onClose,
}: {
  link: string;
  isOpen: boolean;
  onClose: () => void;
}) => {
  const onOpenChangeHandler = (opened: boolean) => {
    if (onClose && !opened) {
      onClose();
    }
  };

  const handleClose = () => {
    if (onClose) {
      onClose();
    }
  };

  return (
    <CustomDialog
      open={isOpen}
      onOpenChange={onOpenChangeHandler}
      withGradient
      description={
        <>
          <div className="flex flex-col items-center gap-4 max-w-[352px] mx-auto">
            <p className=" text-base-text-secondary text-caption-sm-a">Excellent!</p>
            <p className="text-base-text-secondary text-caption-sm-a">
              You are eligible to claim this Hot Offer! Please click “Ok“ button to proceed
            </p>
          </div>
          <DialogButtonsWrapper className="xs-msq:mt-8 flex-col sm-msq:!flex-row">
            <a
              href={link}
              target="_blank"
              rel="noreferrer"
              className="button button-secondary"
              onClick={handleClose}
            >
              Ok
            </a>
          </DialogButtonsWrapper>
        </>
      }
    />
  );
};
